import React from 'react'
import styles from './uploadfile.css'
import {Button} from "antd"

export class DefaultUploadFile extends React.Component {

    constructor(props) {
        super(props);
        this.change = this.change.bind(this);
        this.state = {
            id: 'file' + Math.random()
        }
    }

    change(e) {
        if (this.props.selectFile) {
            this.props.selectFile(e.target.files);
        }
        e.target.value = '';
    }

    render() {
        return (
            <span>
                <input id={this.state.id} type="file" multiple={this.props.multiple} className={'uploadInput'}
                       onChange={this.change}
                       accept={this.props.accept}/>
                <label htmlFor={this.state.id}
                       className={this.props.forPoster ? 'uploadLabelForPoster' : 'uploadLabel'}>{this.props.btnText}</label>

            </span>
        )
    }
}